var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorize-loading-box"},[_c('div',{staticClass:"text-center d-flex col-flex f-auto-center authorize-loading-container"},[_c('h2',[_vm._v("Checking web3 ..."),_c('p',{staticClass:"authorize-loading-icon"},[_c('i',{staticClass:"el-icon-loading"})])])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456f6603","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reuse/dialog/authorize/loading.vue
// module id = null
// module chunks = 